import { toast } from 'react-toastify';

import {
  fetchClientArea,
  fetchClientAreaPlans,
  activateFirstCharge,
  reprocessCreditCardCharge,
  sendChargeEmail
} from './services';

import {
  setClientArea,
  setClientAreaPlans,
  clearClientArea,
  handleLoading,
  handlePlansLoading,
  handleSendEmailLoading
} from './actions';

export const loadClientArea = (userId, establishmentId) => dispatch => {
  dispatch(handleLoading(true));

  return fetchClientArea(userId, establishmentId)
    .then(({ data }) => dispatch(setClientArea(data)))
    .catch(() => dispatch(clearClientArea()))
    .finally(() => dispatch(handleLoading(false)));
}

export const loadClientAreaPlans = (userId, establishmentId) => dispatch => {
  dispatch(handlePlansLoading(true));

  return fetchClientAreaPlans(userId, establishmentId)
    .then(({ data }) => dispatch(setClientAreaPlans(data)))
    .catch(() => dispatch(setClientAreaPlans([])))
    .finally(() => dispatch(handlePlansLoading(false)));
}

export const updateActivateFirstCharge = (userId, establishmentId, params) => dispatch => {
  dispatch(handleLoading(true));

  return activateFirstCharge(userId, establishmentId, params)
    .then(() => {
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const updateReprocessCreditCardCharge = (userId, establishmentId, params) => dispatch => {
  toast.success('Solicitação para reprocessar cobrança enviada.');

  return reprocessCreditCardCharge(userId, establishmentId, params)
    .then(() => dispatch(loadClientArea(userId, establishmentId)));
}

export const sendClientAreaChargeEmail = (userId, params) => dispatch => {
  dispatch(handleSendEmailLoading(true));

  return sendChargeEmail(userId, params)
    .then(({ data }) => {
      toast.success(data?.message);
      return Promise.resolve();
    })
    .catch(() => {
      toast.error('Erro ao enviar a fatura.')
      return Promise.reject();
    })
    .finally(() => dispatch(handleSendEmailLoading(false)));
}